<template>
  <div
    v-if="dragging"
    class="elevation-1 white"
    :style="
      `left: ${dragPosition.x - draggedData.shift.x}px; top: ${dragPosition.y -
        draggedData.shift.y}px; width: ${draggedData.element.offsetWidth}px;
        height: ${
          draggedData.element.offsetHeight
        }px; position: absolute; z-index: 1000; pointer-events: none; opacity: 0.6`
    "
  >
    <div v-html="draggedData.html"></div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
export default {
  computed: {
    ...mapState('components/dragdrop', ['dragPosition', 'draggedData']),
    ...mapGetters('components/dragdrop', ['dragging'])
  },
  watch: {
    dragging: function(n, o) {
      if (n && !o) {
        //  Attach listeners to update drag position and handle misc stop
        document.addEventListener('mousemove', this.updateDragPos);
        document.addEventListener('mouseup', this.handleDragStop);
      } else if (!n && o) {
        //  clean up listeners
        document.removeEventListener('mousemove', this.updateDragPos);
        document.removeEventListener('mouseup', this.handleDragStop);
      }
    }
  },
  methods: {
    ...mapMutations('components/dragdrop', ['setDragPosition', 'resetDragState']),
    updateDragPos(e) {
      const { x, y } = e;
      this.setDragPosition({ x, y });
    },
    handleDragStop() {
      console.log('stop drag');
      this.resetDragState();
    }
  }
};
</script>

<style></style>
